import {
  REQUEST_PLANTING_METADATA,
  RECEIVE_PLANTING_METADATA,
  FAILURE_PLANTING_METADATA,
  RECEIVE_PLANTING_ANALYTICS,
} from '../constants/actionTypes';

export function reqPlantingMetadata(clearState) {
  return {
    type: REQUEST_PLANTING_METADATA,
    clearState,
  };
}

export function receivePlantingMetadata(metadata, season) {
  return {
    type: RECEIVE_PLANTING_METADATA,
    metadata,
    season,
  };
}

export function failurePlantingMetadata(season) {
  return {
    type: FAILURE_PLANTING_METADATA,
    season,
  };
}

export function receivePlantingAnalytics(events) {
  return {
    type: RECEIVE_PLANTING_ANALYTICS,
    events,
  };
}
